.slide {
  position: relative;
  display: grid;
  gap: 20px;

  /* それぞれのスライドはoverlayでカバーするように作る */
  &::after {
    position: absolute;
    top: 0;
    left: 0;

    /* 表示されているスライドはクリックできるようにz-indexを-1にする */
    z-index: -1;
    width: 100%;
    height: 100%;
    content: '';

    /* background-imageはtransition-delayに指定できないので、opacityを使う。 */

    /* 普通に表示されるスライドはoverlayを透明にする */
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }

  &:hover {
    p {
      color: rgb(0 0 0 / 70%);
    }
  }
}

.article {
  display: grid;
  gap: 20px;
}

.imgWrapper {
  display: flex;
  width: 262px;
  height: 148px;

  img {
    flex: 0 0 auto;
    width: 100%;
    object-fit: contain;
  }
}

.description {
  display: grid;
  gap: 16px;
}

.title {
  display: -webkit-box;
  width: 262px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  font-size: 15px;
  font-weight: 600;
  font-feature-settings: 'pcap' on;
  line-height: 1.5;
  -webkit-box-orient: vertical;
}

.date {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: rgb(0 0 0 / 60%);
}

@container press-release-root (min-width: 1280px) {
  .gradientRightToLeftCQ {
    &::after {
      z-index: auto;
      background-image: linear-gradient(
        90deg,
        rgb(255 255 255 / 80%) 0%,
        rgb(255 255 255 / 95%) 75%,
        #fff 100%
      );

      /* 左の突き当たりのスライドはoverlayを表示する */
      opacity: 1;
    }
  }

  .gradientLeftToRightCQ {
    &::after {
      z-index: auto;
      background-image: linear-gradient(
        -90deg,
        rgb(255 255 255 / 80%) 0%,
        rgb(255 255 255 / 95%) 75%,
        #fff 100%
      );

      /* 右の突き当たりのスライドはoverlayを表示する */
      opacity: 1;
    }
  }

  .descriptionCQ {
    gap: 15px;
  }
}

@media screen and (width >= 1280px) {
  .gradientRightToLeftFallback {
    &::after {
      z-index: auto;
      background-image: linear-gradient(
        90deg,
        rgb(255 255 255 / 80%) 0%,
        rgb(255 255 255 / 95%) 75%,
        #fff 100%
      );

      /* 左の突き当たりのスライドはoverlayを表示する */
      opacity: 1;
    }
  }

  .gradientLeftToRightFallback {
    &::after {
      z-index: auto;
      background-image: linear-gradient(
        -90deg,
        rgb(255 255 255 / 80%) 0%,
        rgb(255 255 255 / 95%) 75%,
        #fff 100%
      );

      /*  右の突き当たりのスライドはoverlayを表示する */
      opacity: 1;
    }
  }

  .descriptionFallback {
    gap: 15px;
  }
}
